import React, { useState } from "react";
import "./sub1.css";
import { Helmet } from "react-helmet";
import contactConfig from "../../confi";
export default function PatientCare() {
  const [formData, setFormData] = useState({
    patientName: "",
    familyMemberName: "",
    email: "",
    phone: "",
    patientAge: "",
    condition: "",
    careType: "",
    serviceDate: "",
    address: "",
    specialRequirements: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(
      "Patient care service request submitted successfully! We will contact you soon.",
    );
    // Reset form
    setFormData({
      patientName: "",
      familyMemberName: "",
      email: "",
      phone: "",
      patientAge: "",
      condition: "",
      careType: "",
      serviceDate: "",
      address: "",
      specialRequirements: "",
    });
  };

  const serviceFeatures = [
    {
      icon: "👨‍⚕️",
      text: "Qualified male and female attendants/nurses",
    },
    {
      icon: "🏥",
      text: "Post-hospitalization care for surgery or injury recovery",
    },
    {
      icon: "👵",
      text: "Elderly care with compassion and patience",
    },
    {
      icon: "🚶",
      text: "Support for mobility and hygiene assistance",
    },
    {
      icon: "💊",
      text: "Medication reminders and basic health monitoring",
    },
    {
      icon: "⏰",
      text: "24x7 or part-time home nursing services",
    },
    {
      icon: "🛌",
      text: "Specialized care for bedridden or chronically ill patients",
    },
  ];
  const handleCall = () => {
    window.open(`tel:${contactConfig.phone}`);
  };

  const handleWhatsApp = () => {
    const phoneNumber = `${contactConfig.phone}`;
    const message = "Hello, I would like to know more about your services.";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };

  const whyChooseUs = [
    {
      title: "Verified & Trained Caregivers",
      description:
        "Each caregiver undergoes rigorous background checks and medical training before joining.",
      icon: "✅",
    },
    {
      title: "Skilled Nursing Assistance",
      description:
        "Our attendants are trained to assist in mobility, feeding, personal hygiene, and basic medical needs.",
      icon: "🎓",
    },
    {
      title: "Compassionate Approach",
      description:
        "We believe care is not just a service — it's an emotion. Our team treats your loved one like family.",
      icon: "💖",
    },
    {
      title: "Flexible Timings",
      description:
        "Choose from hourly, daytime, overnight, or full-time caregivers as per your needs.",
      icon: "⏰",
    },
  ];

  const processSteps = [
    {
      step: "1",
      title: "Share Your Care Requirement",
      description: "Let us know the patient's age, condition, and care needs",
    },
    {
      step: "2",
      title: "Profile Shortlisting",
      description:
        "We share verified caregiver profiles best suited to your case",
    },
    {
      step: "3",
      title: "Meet & Select",
      description:
        "You can meet and interview the attendant or nurse before finalizing",
    },
    {
      step: "4",
      title: "Start Service",
      description:
        "Once confirmed, our caregiver begins providing care at your home",
    },
    {
      step: "5",
      title: "Ongoing Support",
      description:
        "We continuously monitor the service to ensure complete satisfaction",
    },
  ];

  const testimonials = [
    {
      name: "Mrs. Neha Shah",
      location: "Satellite, Ahmedabad",
      rating: "⭐⭐⭐⭐⭐",
      text: "JP Home Services sent us a caregiver for my mother after surgery. She was caring, punctual, and extremely professional. It made recovery much easier.",
    },
    {
      name: "Mr. Rakesh Mehta",
      location: "Surat",
      rating: "⭐⭐⭐⭐⭐",
      text: "We hired a full-time attendant for my father. The caregiver was kind, patient, and respectful. Truly thankful for the service.",
    },
    {
      name: "Mrs. Kavita Patel",
      location: "Vadodara",
      rating: "⭐⭐⭐⭐⭐",
      text: "Their patient care staff is trained and very trustworthy. It felt like having a family member around to help.",
    },
  ];

  const benefits = [
    "Verified & medically trained caregivers",
    "24x7 or part-time support options",
    "Dedicated male & female attendants",
    "Trusted by hundreds of premium families",
    "Supervised service & quick replacements",
    "Affordable and transparent pricing",
    "Available in Ahmedabad, Surat, Vadodara, Rajkot, Gandhinagar & nearby cities",
  ];

  const cities = [
    "Ahmedabad",
    "Surat",
    "Vadodara",
    "Rajkot",
    "Gandhinagar",
    "Anand",
    "Bhavnagar",
    "Jamnagar",
  ];

  const carePackages = [
    {
      name: "Basic Care Package",
      price: "₹9,999",
      period: "/month",
      features: [
        "✓ 4 hours daily care",
        "✓ Basic hygiene assistance",
        "✓ Medication reminders",
        "✓ Mobility support",
        "✓ Regular monitoring",
        "✗ Night care",
        "✗ Medical procedures",
      ],
      popular: false,
    },
    {
      name: "Standard Care Package",
      price: "₹16,999",
      period: "/month",
      features: [
        "✓ 8 hours daily care",
        "✓ Complete personal care",
        "✓ Medication management",
        "✓ Basic health monitoring",
        "✓ Mobility assistance",
        "✓ Day & evening care",
        "✗ 24x7 care",
      ],
      popular: true,
    },
    {
      name: "Premium Care Package",
      price: "₹26,999",
      period: "/month",
      features: [
        "✓ 12 hours daily care",
        "✓ Advanced medical care",
        "✓ Special diet management",
        "✓ Regular health updates",
        "✓ Night care included",
        "✓ Emergency support",
        "✓ Priority replacement",
      ],
      popular: false,
    },
    {
      name: "24x7 Live-in Care",
      price: "₹39,999",
      period: "/month",
      features: [
        "✓ Round-the-clock care",
        "✓ Complete medical support",
        "✓ Special needs care",
        "✓ Post-surgery care",
        "✓ Daily health reports",
        "✓ Emergency response",
        "✓ Dedicated caregiver",
      ],
      popular: false,
    },
  ];

  return (
    <div className="main-content-wrapper">
      <Helmet>
        <title>Trusted Patient Care Services in Ahmedabad - JP Home Services</title>
        <meta
          name="description"
          content="Need Patient Care Services in Ahmedabad? JP Homes provides trusted home nursing & recovery support, chosen by 100+ families. Call +91 9328843812."
        />
        <meta
          name="keywords"
          content="Patient Care Services Ahmedabad, Home Nursing Ahmedabad, Trained Caregivers Gujarat, Home Attendants Ahmedabad, Post-Surgery Care Gujarat, Bedridden Patient Care Ahmedabad, Home Nursing Services"
        />
        <meta
          name="robots"
          content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
        />
        <link
          rel="canonical"
          href="https://jphomeservice.in/patient-care-services-in-ahmedabad"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Trusted Patient Care Services in Ahmedabad - JP Home Services"
        />
        <meta
          property="og:description"
          content="Need Patient Care Services in Ahmedabad? JP Homes provides trusted home nursing & recovery support, chosen by 100+ families. Call +91 9328843812."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://jphomeservice.in/patient-care-services-in-ahmedabad"
        />
        <meta
          property="og:image"
          content="https://jphomeservice.in/static/media/Patientcare1.b6deaca6fd8b6ef73a08.png"
        />
        <meta property="og:site_name" content="JP Home Services" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@" />
        <meta
          name="twitter:title"
          content="Trusted Patient Care Services in Ahmedabad - JP Home Services"
        />
        <meta
          name="twitter:description"
          content="Need Patient Care Services in Ahmedabad? JP Homes provides trusted home nursing & recovery support, chosen by 100+ families. Call +91 9328843812."
        />
        <meta
          name="twitter:image"
          content="https://jphomeservice.in/static/media/Patientcare1.b6deaca6fd8b6ef73a08.png"
        />

        {/* JSON-LD */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "LocalBusiness",
              "name": "Patient Care Service in Ahmedabad",
              "image": "https://jphomeservice.in/static/media/TRANSPARNT%20LOGO.1a150556bfeacec71cee.png",
              "@id": "",
              "url": "https://jphomeservice.in/patient-care-services-in-ahmedabad",
              "telephone": "+919327365056",
              "priceRange": "₹₹",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "A-316-317, Swaminarayan Avenue,  Nr. AEC Cross Road, Naranpura",
                "addressLocality": "Ahmedabad, Gujarat",
                "postalCode": "380013",
                "addressCountry": "IN"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 23.0542109,
                "longitude": 72.5482134
              },
              "openingHoursSpecification": {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": [
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                  "Sunday"
                ],
                "opens": "00:00",
                "closes": "23:59"
              },
              "sameAs": [
                "https://www.facebook.com/jphomeservice.in/",
                "https://www.instagram.com/jp_home_service/"
              ] 
            }
          `}
        </script>
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "WebPage",
              "@id": "https://jphomeservice.in/patient-care-services-in-ahmedabad#webpage",
              "url": "https://jphomeservice.in/patient-care-services-in-ahmedabad",
              "name": "Patient Care Taker Services in Ahmedabad - JP Home Services",
              "description": "JP Home Services offers patient care services in Ahmedabad with trained patient care taker for home nursing, recovery & daily medical support. Book now!",
              "inLanguage": "en-IN",
              "isPartOf": {
                "@type": "WebSite",
                "@id": "https://jphomeservice.in/#website",
                "name": "JP Home Services",
                "url": "https://jphomeservice.in/"
              },
              "publisher": {
                "@type": "Organization",
                "@id": "https://jphomeservice.in/#organization",
                "name": "JP Home Services",
                "url": "https://jphomeservice.in/"
              }
            }
          `}
        </script>
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Patient Care Services in Ahmedabad",
            "serviceType": "Patient Care Services",
            "description": "Professional patient care services in Ahmedabad with caring and reliable attendants to support patients at home.",
            "url": "https://jphomeservice.in/patient-care-services-in-ahmedabad",
            "areaServed": {
              "@type": "City",
              "name": "Ahmedabad"
            },
            "provider": {
              "@type": "Organization",
              "name": "JP Home Service",
              "url": "https://jphomeservice.in/"
            }
          }
          `}
        </script>
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://jphomeservice.in/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Patient Care Services in Ahmedabad",
                "item": "https://jphomeservice.in/patient-care-services-in-ahmedabad"
              }
            ]
          }
          `}
        </script>
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Review",
                "author": {
                  "@type": "Person",
                  "name": "Mrs. Neha Shah"
                },
                "reviewBody": "JP Home Services sent us a caregiver for my mother after surgery. She was caring, punctual, and extremely professional. It made recovery much easier.",
                "reviewRating": {
                  "@type": "Rating",
                  "ratingValue": 5,
                  "bestRating": 5,
                  "worstRating": 1
                }
              },
              {
                "@type": "Review",
                "author": {
                  "@type": "Person",
                  "name": "Mr. Rakesh Mehta"
                },
                "reviewBody": "We hired a full-time attendant for my father. The caregiver was kind, patient, and respectful. Truly thankful for the service.",
                "reviewRating": {
                  "@type": "Rating",
                  "ratingValue": 5,
                  "bestRating": 5,
                  "worstRating": 1
                }
              },
              {
                "@type": "Review",
                "author": {
                  "@type": "Person",
                  "name": "Mrs. Kavita Patel"
                },
                "reviewBody": "Their patient care staff is trained and very trustworthy. It felt like having a family member around to help.",
                "reviewRating": {
                  "@type": "Rating",
                  "ratingValue": 5,
                  "bestRating": 5,
                  "worstRating": 1
                }
              },
              {
                "@type": "AggregateRating",
                "ratingValue": 5,
                "bestRating": 5,
                "worstRating": 1,
                "ratingCount": 3,
                "reviewCount": 3
              }
            ]
          }
          `}
        </script>
      </Helmet>
      <div className="patient-care-container">
        {/* Hero Section */}
        <section className="patient-hero-section">
          <div className="container">
            <div className="patient-hero-content">
              <h1>
                Patient Care Services at Home in Ahmedabad, Surat & Across
                Gujarat
              </h1>
              <p className="hero-subtitle">
                <strong>
                  Compassionate, Trained, and Trustworthy Caregivers — Because
                  Healing Deserves Comfort at Home
                </strong>
              </p>
              <p className="hero-description">
                When a loved one needs medical attention, post-surgery care, or
                assistance with daily activities, nothing feels better than
                receiving care in the comfort of home.
              </p>
              <p className="hero-description">
                At JP Home Services, we provide professional, trained, and
                compassionate caregivers and nurses who ensure your family
                members get personalized patient care right at home — with
                dignity, comfort, and respect.
              </p>
              <p className="hero-description">
                Whether it's post-surgery recovery, elderly care, or long-term
                health support, our caregivers are trained to provide the right
                balance of medical assistance and emotional comfort for your
                loved ones.
              </p>
              <div className="hero-stats">
                <div className="stat-item">
                  <span className="stat-number">1000+</span>
                  <p className="stat-label">Patients Served</p>
                </div>
                <div className="stat-item">
                  <span className="stat-number">100%</span>
                  <p className="stat-label">Verified Staff</p>
                </div>
                <div className="stat-item">
                  <span className="stat-number">24/7</span>
                  <p className="stat-label">Care Available</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="floating-contact-icons">
          <div className="contact-icon whatsapp-icon" onClick={handleWhatsApp}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893c0-3.18-1.24-6.169-3.495-8.424" />
            </svg>
          </div>
          <div className="contact-icon call-icon" onClick={handleCall}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 10.999h2C22 5.869 18.127 2 12.99 2v2C17.052 4 20 6.943 20 10.999z" />
              <path d="M13 8c2.103 0 3 .897 3 3h2c0-3.225-1.775-5-5-5v2zm3.422 5.443a1.001 1.001 0 00-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 00.043-1.391L6.859 3.513a1 1 0 00-1.391-.087l-2.17 1.861a1 1 0 00-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 00.648-.291l1.86-2.171a1 1 0 00-.086-1.391l-4.064-3.696z" />
            </svg>
          </div>
        </div>

        {/* Service Features Section */}
        <section className="service-features-section">
          <div className="container">
            <div className="section-header1">
              <h2>Our Patient Care Service Features</h2>
              <p>
                Our patient care services are designed to support recovery,
                safety, and emotional well-being at home.
              </p>
            </div>

            <div className="features-grid">
              {serviceFeatures.map((feature, index) => (
                <div key={index} className="feature-item">
                  <div className="feature-icon1">{feature.icon}</div>
                  <span>{feature.text}</span>
                </div>
              ))}
            </div>

            <div className="flexibility-note">
              <p>
                <strong>
                  Your loved one deserves care that's both professional and kind
                  — we provide exactly that.
                </strong>
              </p>
            </div>
          </div>
        </section>

        {/* Pricing Packages Section */}
        {/* <section className="pricing-packages-section">
          <div className="container">
            <div className="section-header1">
              <h2>Patient Care Packages</h2>
              <p>Comprehensive patient care packages designed for different medical needs and recovery stages</p>
            </div>

            <div className="packages-grid">
              {carePackages.map((pkg, index) => (
                <div key={index} className={`package-card ${pkg.popular ? 'popular' : ''}`}>
                  {pkg.popular && <div className="popular-badge">Most Popular</div>}
                  <h3>{pkg.name}</h3>
                  <div className="package-price">
                    {pkg.price}<span>{pkg.period}</span>
                  </div>
                  <ul className="package-features">
                    {pkg.features.map((feature, idx) => (
                      <li key={idx} className={feature.startsWith('✗') ? 'not-included' : ''}>
                        {feature}
                      </li>
                    ))}
                  </ul>
                  <button className="package-btn">
                    Select Package
                  </button>
                </div>
              ))}
            </div>
          </div>
        </section> */}

        {/* Why Choose Us Section */}
        <section className="why-choose-section">
          <div className="container">
            <div className="section-header1">
              <h2>Why Choose JP Home Services for Patient Care</h2>
              <p>
                Families across Gujarat trust JP Home Services because we go
                beyond just providing caregivers — we deliver peace of mind.
                Here's why thousands of homes choose us for patient care:
              </p>
            </div>

            <div className="features-grid">
              {whyChooseUs.map((feature, index) => (
                <div key={index} className="feature-card">
                  <div className="feature-icon1">{feature.icon}</div>
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              ))}
            </div>

            <div className="additional-benefits">
              <div className="benefit-item">
                <span className="check-icon">✓</span>
                <span>
                  Regular Monitoring & Feedback - We stay in touch to ensure
                  consistent quality and satisfaction
                </span>
              </div>
              <div className="benefit-item">
                <span className="check-icon">✓</span>
                <span>
                  Emergency Replacement & Support - Quick replacement and
                  assistance whenever required — ensuring care never stops
                </span>
              </div>
            </div>

            <div className="trust-note">
              <p>
                <strong>
                  We don't just send caregivers — we send comfort, confidence,
                  and care.
                </strong>
              </p>
            </div>
          </div>
        </section>

        {/* How It Works Section */}
        <section className="process-section">
          <div className="container">
            <div className="section-header1">
              <h2>How Our Patient Care Service Works</h2>
              <p>We've made our process simple, transparent, and reliable:</p>
            </div>

            <div className="process-steps">
              {processSteps.map((step, index) => (
                <div key={index} className="process-step">
                  <div className="step-number">{step.step}</div>
                  <div className="step-content">
                    <h3>{step.title}</h3>
                    <p>{step.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="process-conclusion">
              <p>
                <strong>
                  From first call to consistent care — we're with you every step
                  of the way.
                </strong>
              </p>
            </div>
          </div>
        </section>
        {/* Testimonials Section */}
        <section className="testimonials-section">
          <div className="container2">
            <h2> What Families Say About Us</h2>
            <div className="testimonials-grid">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="testimonial-card">
                  <div className="testimonial-rating">{testimonial.rating}</div>
                  <p className="testimonial-text">"{testimonial.text}"</p>
                  <div className="testimonial-author">
                    <strong>{testimonial.name}</strong>
                    <span>{testimonial.location}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="benefits-section">
          <div className="container">
            <div className="section-header1">
              <h2>Benefits of Choosing JP Home Services for Patient Care</h2>
              <p>
                With JP Home Services, you choose comfort, professionalism, and
                empathy under one roof.
              </p>
            </div>

            <div className="benefits-grid">
              {benefits.map((benefit, index) => (
                <div key={index} className="benefit-item-large">
                  <span className="check-icon">✓</span>
                  <span>{benefit}</span>
                </div>
              ))}
            </div>

            <div className="brand-tagline">
              <p>
                <strong>
                  Because healing begins where comfort lives — at home.
                </strong>
              </p>
            </div>
          </div>
        </section>

        {/* Service Coverage Section */}
        <section className="coverage-section">
          <div className="container">
            <div className="section-header1">
              <h2>Our Service Locations</h2>
              <p>We proudly serve across Gujarat, including:</p>
            </div>

            <div className="cities-grid">
              {cities.map((city, index) => (
                <div key={index} className="city-item">
                  {city}
                </div>
              ))}
            </div>

            <div className="coverage-note">
              <p>
                <strong>
                  Whether you need elderly care, post-surgery support, or daily
                  nursing assistance, we ensure trusted caregivers reach your
                  doorstep with the highest standards of care.
                </strong>
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
